export default __webpack_public_path__ + "static/media/Shopping.d1a2a2fc.PNG";